import * as React from "react";
import cx from "classnames";

import {
  trackPixel,
  trackOpenAiPixel,
  trackGoogleAdsAppDownloadIntent,
  trackStoreClick,
} from "../utils/analytics";
import { useStoreLinks } from "../utils/storeLinks";

import AppStoreBtn from "../images/button_download_app-store.svg";
import AndroidBtn from "../images/google-play-badge.svg";

// Real links, so they work without JavaScript and crawlers can follow them.
// Tracking fires on click and never stands between the visitor and the store.
export const StoreButtons = ({
  campaign,
  iosUrl,
  androidUrl,
  className,
  buttonClassName,
}) => {
  // The page's tag, with the visit's inbound source added once it is known.
  const links = useStoreLinks(campaign);

  const trackClick = (platform, storeName) => {
    trackPixel("Lead", {
      content_name: `Redirect to ${storeName}`,
      content_category: `${platform} - App Download Intent`,
    });
    trackOpenAiPixel("lead_created", { type: "customer_action" });
    trackGoogleAdsAppDownloadIntent(platform);
    trackStoreClick(platform, links.campaign);
  };

  return (
    <div className={cx("store-buttons flex gap-4", className)}>
      <a
        href={iosUrl || links.appStoreUrl}
        target="_blank"
        rel="noreferrer"
        className={cx("block shrink-0", buttonClassName)}
        onClick={() => trackClick("iOS", "Apple Store")}
      >
        <img
          src={AppStoreBtn}
          alt="Download Schengen Simple on the App Store"
          className="h-[64px] w-auto max-w-none"
        />
      </a>
      <a
        href={androidUrl || links.googleStoreUrl}
        target="_blank"
        rel="noreferrer"
        className={cx("block shrink-0", buttonClassName)}
        onClick={() => trackClick("Android", "Google Play Store")}
      >
        <img
          src={AndroidBtn}
          alt="Get Schengen Simple on Google Play"
          className="h-[64px] w-auto max-w-none"
        />
      </a>
    </div>
  );
};
